require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-centering-indigenous-leadership-in-the-idbs-amazon.json") })
        }
      }, "path---en-us-update-centering-indigenous-leadership-in-the-idbs-amazon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-centering-indigenous-leadership-in-the-idbs-amazon!./.cache/json/en-us-update-centering-indigenous-leadership-in-the-idbs-amazon.json
// module id = 634
// module chunks = 231608221292675